import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import b2c from '../assets/images/b2c-white-label-head.jpg';

const step = [
	'No minimum wallet',
	'Same day delivery',
	'Pre Integrated GDS & APIs.',
	'Multiple Supplier Inventory',
	'Offline Flight Inventory Management',
	'Real time booking',
	'Real time cancellation',
	'Real time availability',
	'Live Fare rules',
	'Responsive design',
	'All device support',
	'Custom B2C Home Page',
	'Logo Design',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const B2CWL = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${b2c})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					B2C WHITE LABEL
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					B2C White Label
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30 }}>
					B2C White Label Travel Website
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/b2c.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								Arya Aviation is BEST WHITE LABEL SYSTEM providing company in
								TRAVEL INDUSTRY. WHITE LABEL TRAVEL PORTAL is a one stop
								solution provider for all the technology needs of travel agents,
								consolidators, corporate travel consultants, hotelier and tour
								operators.
							</p>
							<br />
							<p>
								The person who have interest in travel business can start his
								business by getting a B2C WHITE LABEL SYSTEM with a little
								investment. B2C WHITE LABEL SYSTEM helps the travel portals to
								display all the service related searches together like flight
								booking, car / bus booking, hotel booking at a place.
							</p>
							<br />
							<p>
								B2C Travel Portal Solution provides self-service tools to
								clients where they can make online bookings, generate their own
								booking vouchers. B2C End user can check the bookings & payments
								history and send a request for cancellation at any time from
								anywhere by login in Customer Dashboard. B2C Travel Portal
								allows your guests and registered customers to book directly
								without intervention of tour operators. We have API Integration
								expertise which offers your customers a wide range of options to
								select from. Customers can book flights booking, hotels booking,
								car booking, bus booking, holiday, sightseeing, cruise, recharge
								and pay utilities bills, etc through the user friendly B2C
								Travel Portal.
							</p>
							<p>
								In B2C Portal, system allows end user to choose and book ticket
								as per their preference.
							</p>
						</Grid>
					</Grid>
				</Container>
			</div>
			<div style={{ background: '#0a74c0', padding: 13 }}>
				<Container>
					<p style={{ color: 'white', fontSize: 14 }}>
						The fastest way to grow your business with the leader in Travel
						Technology Check out our options and features included.
					</p>
				</Container>
			</div>
			<Container style={{ background: '#eaeaea', marginTop: 20, padding: 20 }}>
				<p style={{ fontSize: 14, fontWeight: 'bold' }}>
					Features of B2C Travel Portal:-
				</p>
			</Container>
			<Container style={{ marginTop: 10 }}>
				<Grid container>
					<Grid item xs={4}>
						{step.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
					<Grid item xs={4}>
						{step2.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
					<Grid item xs={4}>
						{step3.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
				</Grid>
			</Container>
			<Footer />
		</div>
	);
};

export default B2CWL;
